import { httpsCallable } from "firebase/functions";
import { Clients } from "src/contexts/AppContext";

export interface GetReferralCodeResponse {
  code: string;
}

export interface GetReferralCodeRequest {
  /** Admin-only override for the student currently selected in Dial. */
  userId?: string;
}

/** Fetch a permanent referral code (the caller's own unless `userId` is set). */
export default async function getReferralCode(
  { functions }: Clients,
  userId?: string
): Promise<GetReferralCodeResponse> {
  const callable = httpsCallable<
    GetReferralCodeRequest,
    GetReferralCodeResponse
  >(functions, "getOrCreateReferralCode");
  const result = await callable(userId === undefined ? {} : { userId });
  return result.data;
}
